export enum SessionStorageEnum {
  SESSION_ID = 'SESSION_ID',
  RECAPTCHA = 'RECAPTCHA',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER_AUTH = 'USER_AUTH',
  USERNAME = 'USERNAME'
}
